/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Measures_Load_FailedInputs */

const en_us2_body_measures_load_failed = /** @type {(inputs: Body_Measures_Load_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couldn't load your measurements.`)
};

const pt_br2_body_measures_load_failed = /** @type {(inputs: Body_Measures_Load_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não deu para carregar as medidas.`)
};

const es_419_body_measures_load_failed = /** @type {(inputs: Body_Measures_Load_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudieron cargar tus medidas.`)
};

const pt_pt2_body_measures_load_failed = /** @type {(inputs: Body_Measures_Load_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não foi possível carregar as medidas.`)
};

const fr_fr2_body_measures_load_failed = /** @type {(inputs: Body_Measures_Load_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossible de charger tes mensurations.`)
};

const de_de2_body_measures_load_failed = /** @type {(inputs: Body_Measures_Load_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deine Umfänge konnten nicht geladen werden.`)
};

const it_it2_body_measures_load_failed = /** @type {(inputs: Body_Measures_Load_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossibile caricare le tue misure.`)
};

/**
* | output |
* | --- |
* | "Couldn't load your measurements." |
*
* @param {Body_Measures_Load_FailedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_measures_load_failed = /** @type {((inputs?: Body_Measures_Load_FailedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Measures_Load_FailedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_measures_load_failed(inputs)
	if (locale === "es-419") return es_419_body_measures_load_failed(inputs)
	if (locale === "pt-PT") return pt_pt2_body_measures_load_failed(inputs)
	if (locale === "fr-FR") return fr_fr2_body_measures_load_failed(inputs)
	if (locale === "de-DE") return de_de2_body_measures_load_failed(inputs)
	if (locale === "it-IT") return it_it2_body_measures_load_failed(inputs)
	return en_us2_body_measures_load_failed(inputs)
});
export { body_measures_load_failed as "body-measures.load_failed" }